import { siteConfig } from "../data/seo.js";

function whatsappHref() {
  const number = siteConfig.whatsappNumber.replace(/\D/g, "");
  const text = encodeURIComponent(siteConfig.whatsappMessage);
  return number ? `https://wa.me/${number}?text=${text}` : `https://wa.me/?text=${text}`;
}

export default function FloatingWhatsApp() {
  return (
    <a
      className="whatsapp-float"
      href={whatsappHref()}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with ContiGO Freeze Foods on WhatsApp"
    >
      <span className="whatsapp-icon" aria-hidden="true">
        <svg viewBox="0 0 32 32" focusable="false">
          <path d="M16 3.4A12.5 12.5 0 0 0 5.2 22.2L3.6 28.6l6.6-1.5A12.5 12.5 0 1 0 16 3.4Zm0 2.4a10.1 10.1 0 1 1-5.2 18.8l-.5-.3-3.2.8.8-3.1-.3-.5A10.1 10.1 0 0 1 16 5.8Zm-4.5 5.4c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.2 5 4.3 2.5 1 3 .8 3.5.8.5-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.1-.3-.2-.6-.4l-1.8-.9c-.3-.1-.5-.2-.7.2-.2.3-.8.9-.9 1.1-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.5-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.6c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.6l-.8-1.9c-.2-.5-.4-.5-.7-.5h-.6Z" />
        </svg>
      </span>
      <span className="whatsapp-label">WhatsApp Inquiry</span>
    </a>
  );
}
